import { useEffect } from "react";

import { SHORT_URL_EVENTS } from "@/modules/tracking/consts/Events";
import {
  endShortUrlFlowSession,
  getShortUrlFlowSession,
  timeInFlowSeconds,
} from "@/modules/tracking/utils/shortUrlFlowSession";
import { trackShortUrlEvent } from "@/modules/tracking/utils/trackShortUrlEvent";

export function useShortUrlFlowAbandonment(): void {
  useEffect(() => {
    let fired = false;

    const handler = () => {
      if (fired) return;
      const session = getShortUrlFlowSession();
      if (!session) return;
      fired = true;

      trackShortUrlEvent(SHORT_URL_EVENTS.FLOW_ABANDONED, {
        flow: session.flow,
        session_id: session.sessionId,
        source: session.source,
        last_screen: session.lastScreen,
        time_in_flow_seconds: timeInFlowSeconds(session.startedAt),
      });

      // Clear so a stale session doesn't fire abandoned on a future visit
      // if the tab gets reused (bfcache restore, etc.).
      endShortUrlFlowSession();
    };

    window.addEventListener("pagehide", handler);
    window.addEventListener("beforeunload", handler);
    return () => {
      window.removeEventListener("pagehide", handler);
      window.removeEventListener("beforeunload", handler);
    };
  }, []);
}
